export let dto_cart_checkout = {
  Cart: Array,
  Total: Number,
  TaxTotal: Number,
  ServiceCharge: Number,
  DiscountTotal: Number,
  RowDiscountTotal: Number,
  SubTotal: Number,
  DisplaySubtotal: Number,
  PromoGuid: Number,
  PromoCODE: String,
  PromoHeader: String,
  DiscountPersentage: Number,
  XMLTaxDoc: Array,
  IPGUrl: String,
  IPGUsername: String,
  IPGPassword: String,
  IPGMerchantNumber: String,
  PayModeTypes: String,
  BankTransferAccountDetails: String,
  Comment: String
};